export default __webpack_public_path__ + "static/media/faq.5d58f39c.svg";